<template>
  <main-layout
    :head-title="$t('licenseManager')"
    :show-menu="false"
    :show-right-menu="true"
    :show-footer-menu="false"
    :show-back-button="false"
    :key="'license-list'"
    :mainContainerClass="'uk-container uk-container-expand'"
  >
    <div class="uk-grid-small" uk-grid>
      <div class="uk-width-1-1 uk-width-expand">
        <h3 class="uk-heading-divider">
          <div class="uk-flex uk-flex-between">
            <span v-text="$t('licenses')"></span>
            <span class="uk-flex-inline uk-flex-right">
              <span class="uk-search uk-search-default uk-background-default">
                <span uk-search-icon></span>
                <input
                  class="uk-search-input uk-text-default"
                  v-on:input="startSearch({ search: ($event.target as HTMLInputElement).value })"
                  :value="like"
                  type="search"
                  :placeholder="$t('search')"
                />
              </span>
              <router-link
                custom
                v-slot="{ navigate }"
                :to="{ name: 'editlicense' }"
              >
                <button
                  @click="navigate"
                  class="uk-button uk-text-middle uk-margin-left uk-button-primary uk-button-small"
                  v-text="$t('add_new')"
                ></button>
              </router-link>
            </span>
          </div>
        </h3>

        <panel-box class="uk-overflow-auto-">
          <template v-if="isLoading">
            <div class="uk-text-center"><span uk-spinner></span></div>
          </template>

          <div class="stickyTable">
            <table
              class="uk-table uk-table-striped uk-table-hover uk-table-small"
            >
              <thead>
                <tr class="uk-position-z-index">
                  <th
                    class="uk-text-top"
                    v-for="header in tableHeaders"
                    :key="header.name"
                  >
                    <span
                      @click="
                        setSort({ field: header.sortName, asc: !sort.asc })
                      "
                      class=""
                    >
                      <div class="uk-text-nowrap">
                        <span>{{ $t(header.name) }}</span>
                        <!--<template v-if="sort.field === header.sortName">
                          <div
                            v-if="sort.asc"
                            uk-icon="icon: triangle-up; ratio: 1"
                          ></div>
                          <div
                            v-if="!sort.asc"
                            uk-icon="icon: triangle-down; ratio: 1"
                          ></div>
                        </template>-->
                        <div v-if="header.name == 'role'">
                          <select
                            @change="startSearch({ appRoleId: ($event.target as HTMLSelectElement).value })"
                            :value="appRoleId"
                            class="uk-select uk-width-small uk-form-small"
                          >
                            <option value="" v-text="$t('all')"></option>
                            <option
                              v-for="role in getAllRoles()"
                              :value="role.id"
                              :key="role.id"
                            >
                              {{ $getLocalizedText(role.name, $i18n.locale) }}
                            </option>
                          </select>
                        </div>
                        <div v-else-if="header.name == 'customer'">
                          <v-select
                            @input="startSearch({ customerId: $event })"
                            :value="
                              companiesSorted.find(
                                (comp) => comp.id == customerId
                              )
                            "
                            :append-to-body="true"
                            autocomplete="off"
                            placeholer="Kunde"
                            :reduce="(comp) => comp.id"
                            class="v-select uk-width-medium"
                            label="name"
                            :options="companiesSorted"
                          ></v-select>
                        </div>
                        <div v-else-if="header.name == 'lastDayOfValidity'">
                          <select
                            @change="
                              startSearch({
                                validity: ($event.target as HTMLInputElement).value,
                              })
                            "
                            :value="validity"
                            class="uk-select uk-width-small uk-form-small"
                          >
                            <option :value="null" v-text="$t('all')"></option>
                            <option :value="1">Gültig</option>
                            <option :value="0">Abgelaufen</option>
                          </select>
                        </div>
                      </div>
                    </span>
                  </th>
                </tr>
              </thead>
              <tbody>
                <router-link
                  custom
                  v-slot="{ navigate }"
                  :to="{
                    name: 'editlicense',
                    params: { userId: license.id },
                  }"
                  v-for="(license, index) in getAppUsersSorted()"
                  :key="index"
                >
                  <tr @click="navigate" @keydown.enter="navigate()" tabindex="0" style="cursor: pointer" :title="$t('edit')">
                  <td>{{ license.username }}</td>
                  <td>{{ license.firstname }}</td>
                  <td>{{ license.lastname }}</td>
                  <td>{{ license.email }}</td>
                  <Can I="manage" a="Customer">
                    <td>
                      <ul
                        class="uk-list uk-list-divider uk-list-collapse uk-list-hyphen"
                      >
                        <li
                          :key="customeraccess.id"
                          v-for="customeraccess in license.customeraccess"
                        >
                          {{ typeof customeraccess.customer === 'object' ? customeraccess.customer.name : '' }}
                        </li>
                      </ul>
                    </td>
                  </Can>

                    <td>
                      <ul
                        class="uk-list uk-list-divider uk-list-collapse uk-list-hyphen"
                      >
                        <li
                          :key="customeraccess.id"
                          v-for="customeraccess in license.customeraccess"
                        >
                          {{ customeraccess.company }}
                        </li>
                      </ul>
                    </td>
                    <td>
                      <ul
                        class="uk-list uk-list-divider uk-list-collapse uk-list-hyphen"
                      >
                        <li
                          :key="customeraccess.id"
                          v-for="customeraccess in license.customeraccess"
                        >
                          {{ $getLocalizedText(customeraccess.appRole.name, $i18n.locale) }}
                        </li>
                      </ul>
                    </td>
                    <td>
                      <ul
                        class="uk-list uk-list-divider uk-list-collapse uk-list-hyphen"
                      >
                        <li
                          :key="customeraccess.id"
                          v-for="customeraccess in license.customeraccess"
                        >
                          <template v-if="customeraccess.expiresAt">
                            {{
                              $moment(customeraccess.expiresAt)
                                .subtract(1, 'day')
                                .format('ll')
                            }}
                          </template>
                          <template v-if="!customeraccess.expiresAt">
                            ∞</template
                          >
                        </li>
                      </ul>
                    </td>

                    <td>{{ $moment(license.createdAt).format('lll') }}</td>
                    <td>
                      <template
                        v-if="
                          license.updatedAt &&
                          license.createdAt != license.updatedAt
                        "
                      >
                        {{ $moment(license.updatedAt).format('lll') }}
                      </template>
                    </td>
                    <td>
                      <template v-if="license.lastLogin">{{
                        $moment(license.lastLogin).format('lll')
                      }}</template>
                      <template v-else>-</template>
                    </td>
                    <!--<td>
                  {{
                    $t('offlineRevalidTimes.' + license.offlineRevalidationTime)
                  }}
                </td>-->

                    <Can I="manage" a="Customer">
                      <td>
                        <template v-if="license.appVersion">{{
                          license.appVersion
                        }}</template>
                        <template v-else>?</template>
                      </td>
                    </Can>
                  <td>
                    <span
                      :class="{ 'uk-text-danger': !license.userIsConfirmed }"
                      :uk-icon="license.userIsConfirmed ? 'check' : 'close'"
                    ></span>
                  </td>
                  </tr>
                </router-link>
              </tbody>
            </table>
          </div>
        </panel-box>

        <ul v-if="!isLoading" class="uk-pagination uk-flex-center" uk-margin>
          <li>
            <router-link
              v-if="hasPrevPage()"
              :to="{
                name: 'listlicenses',
                query: getQueryParams(currentPage - 1),
              }"
              ><span uk-pagination-previous></span
            ></router-link>
          </li>
          <li
            :class="isActivePage(index) ? 'uk-active' : ''"
            v-for="(page, index) in pages"
            :key="index"
          >
            <span v-if="isActivePage(index)">{{ index + 1 }}</span>
            <router-link
              v-else
              :to="{
                name: 'listlicenses',
                query: getQueryParams(index + 1),
              }"
              >{{ index + 1 }}</router-link
            >
          </li>
          <li>
            <router-link
              v-if="hasNextPage()"
              :to="{
                name: 'listlicenses',
                query: getQueryParams(currentPage + 1),
              }"
              ><span uk-pagination-next></span
            ></router-link>
          </li>
        </ul>
      </div>
    </div>
  </main-layout>
</template>

<script lang="ts">
import { Action } from '@license-manager/casl-rules';
import MainLayout from '../layouts/MainLayout.vue';
import PanelBox from '../components/PanelBox.vue';
import { createNamespacedHelpers } from 'vuex';
import { Options as Component, Vue, Watch } from 'vue-property-decorator';
import { namespace } from 'vuex-class';
import type { IAppRole, IAppUser, ICustomer } from '@license-manager/types';
import { EAppRoles } from '@license-manager/types';
import type { GetAppUsersParams } from '../store/licenses';
import vSelect from 'vue-select';
import RoleSelect from '../components/RoleSelect.vue';

const { mapActions, mapState, mapMutations, mapGetters } =
  createNamespacedHelpers('licenses');
const { mapState: mapCompaniesState, mapGetters: mapCompaniesGetters } =
  createNamespacedHelpers('companies');

const licenses = namespace('licenses');
const companies = namespace('companies');
const user = namespace('user');
const approles = namespace('approles');

@Component({
  name: 'ListLicenses',
  components: { PanelBox, MainLayout, vSelect, RoleSelect },
  i18n: {
    // `i18n` option, setup locale info for component
    messages: {
      en: {
        licenseManager: 'Door Assistant License Manager',
        user: 'User',
        firstname: 'Firstname',
        lastname: 'Lastname',
        email: 'Email',
        company: 'Company',
        role: 'Role',
        customercode: 'Customercode',
        customer: 'Customer',
        createdAt: 'Created at',
        changedAt: 'Changed at',
        lastLogin: 'Last login',
        offlineRevalidTime: 'Offline validity time',
        expires: 'Expires at',
        edit: 'Edit',
        add_new: 'Add license',
        licenses: 'Licenses',
        userIsConfirmed: 'Registration confirmed',
        appVersion: 'App Version',
      },
      de: {
        licenseManager: 'Door Assistant Lizenzverwaltung',
        user: 'Benutzer',
        firstname: 'Vorname',
        lastname: 'Nachname',
        email: 'Email',
        company: 'Firma',
        role: 'Rolle',
        customercode: 'Kundencode',
        customer: 'Kunde',
        createdAt: 'Erstellt am',
        changedAt: 'Geändert am',
        lastLogin: 'Letzter Login',
        offlineRevalidTime: 'Offline Gültigkeitszeit',
        expires: 'Gültig bis',
        edit: 'Bearbeiten',
        add_new: 'Neue Lizenz',
        licenses: 'Lizenzen',
        userIsConfirmed: 'Registrierung bestätigt',
        appVersion: 'App version',
      },
    },
  },
})
class ListLicenses extends Vue {
  @licenses.Action('getAppusers') getAppusers: (
    params?: GetAppUsersParams
  ) => Promise<void>;

  @licenses.Mutation('setSort') setSort: ({ field, asc }) => void;

  @licenses.State('isLoading') isLoading: boolean;
  @licenses.State('appusers') appusers: IAppUser[];
  @licenses.State('sort') sort: any;

  @licenses.Getter('getAppUsersSorted') getAppUsersSorted: (
    field?,
    asc?
  ) => IAppUser[];

  @licenses.Getter('totalCount') totalCountOfLicenses: number;

  @companies.Getter('alphaSorted') companiesSorted: ICustomer[];
  @companies.Action('loadCompanies') loadCompanies: () => Promise<any>;

  async mounted() {
    this.loadCompanies();
    this.loadRoles({ includeRights: false, loadAllRoles: true });
    if (!this.appusers) {
      this.setQueryParamsByUrlAndLoad();
    }
  }

  get tableHeaders() {
    const addCustomer = this.$ability.can(Action.Manage, 'Customer');

    return [
      { name: 'user', sortName: 'username' },
      { name: 'firstname', sortName: 'firstname' },
      { name: 'lastname', sortName: 'lastname' },
      { name: 'email', sortName: 'email' },
      addCustomer ? { name: 'customer' } : null,
      { name: 'company', sortName: 'company' },
      { name: 'role', sortName: 'role' },
      { name: 'lastDayOfValidity', sortName: 'expiresAt' },
      /*addCustomer ? { name: 'customercode', sortName: 'customer.hc' } : null,*/
      /*addCustomer ? { name: 'customer', sortName: 'customer.name' } : null,*/
      { name: 'createdAt', sortName: 'createdAt' },
      { name: 'changedAt', sortName: 'updatedAt' },
      { name: 'lastLogin', sortName: 'lastLogin' },
      /*{ name: 'offlineRevalidTime', sortName: 'offlineRevalidationTime' },*/

      addCustomer ? { name: 'appVersion', sortName: 'appVersion' } : null,
      { name: 'userIsConfirmed', sortName: 'userIsConfirmed' },
    ].filter((e) => Boolean(e));
  }

  public take;
  like = null;
  currentPage;
  index;
  appRoleId = null;
  customerId;
  validity = null;

  getQueryParams(page) {
    const params = {};

    if (this.take) {
      params['take'] = this.take;
    }

    if (this.like) {
      params['like'] = this.like;
    }

    if (this.appRoleId) {
      params['appRoleId'] = this.appRoleId;
    }

    if (this.customerId) {
      params['customerId'] = this.customerId;
    }

    if (this.validity) {
      params['validity'] = this.validity;
    }

    if (page) {
      params['page'] = page;
    }

    return params;
  }

  @approles.Getter('getAllRoles')
  getAllRoles: (customerId?: number) => IAppRole[];

  @approles.Action('loadRoles')
  loadRoles: (params: {
    includeRights: boolean;
    loadAllRoles: boolean;
    customerId?: number;
  }) => Promise<void>;


  @Watch('$route.query')
  async setQueryParamsByUrlAndLoad() {
    this.take = this.$route.query['take'] ?? 50;
    this.currentPage = this.$route.query['page'] ?? 1;
    this.like = (this.$route.query['like'] as string) ?? '';
    this.appRoleId = (this.$route.query['appRoleId'] as string) ?? '';
    this.customerId = (this.$route.query['customerId'] as string) ?? '';
    this.validity = (this.$route.query['validity'] as string) ?? null;

    await this.getAppusers({
      appRoleId: this.appRoleId,
      take: this.take,
      skip: this.skip(),
      like: this.like,
      customerId: this.customerId,
      validity: this.validity,
    });
  }

  skip() {
    return (this.currentPage - 1) * this.take;
  }

  hasNextPage() {
    return this.currentPage + 1 <= this.pages.length;
  }

  hasPrevPage() {
    return this.currentPage > 1;
  }

  isActivePage(index) {
    return index + 1 == this.currentPage;
  }

  get approles() {
    return EAppRoles;
  }

  startSearch({
    search = this.like,
    appRoleId = this.appRoleId,
    customerId = this.customerId,
    validity = this.validity,
  }: {
    search?: string;
    appRoleId?: string;
    customerId?: number;
    validity?: string;
  }) {
    const query = {};

    query['like'] = search;
    query['appRoleId'] = appRoleId;
    query['customerId'] = customerId;

    if (validity != '') {
      query['validity'] = validity;
    }

    this.$router.replace({
      path: this.$route.path,
      query,
    });
  }

  get pages() {
    const length = Math.ceil(this.totalCountOfLicenses / this.take);
    return Array.from({ length: length });
  }
}

export default ListLicenses;
</script>

<style  lang="scss">
@import '../../../../node_modules/vue-select/dist/vue-select.css';

.v-select .vs__dropdown-toggle {
  max-width: 100%;
  width: 100%;
  border-radius: inherit;
  background: #fff;
  border: 1px solid #e5e5e5;
  -webkit-transition: 0.2s ease-in-out;
  transition: 0.2s ease-in-out;
  -webkit-transition-property: color, background-color, border;
  transition-property: color, background-color, border;
}

.v-select.uk-form-danger .vs__dropdown-toggle {
  color: #f0506e;
  border-color: #f0506e;
}

.v-select .vs__search {
  line-height: 24px;
}

.v-select .vs__selected {
  color: #666;
  line-height: 24px;
}

.v-select .vs__dropdown-menu {
  color: #666;
}

.v-select svg {
  max-width: inherit;
}

.stickyTable {
  overflow: auto;
  max-height: calc(100vh - 273px);
  overflow-y: scroll;
}
.stickyTable thead th {
  position: sticky;
  top: 0;
  z-index: 1;
}

th {
  background: white;
}
</style>
